import classcat from "classcat";
import React from "react";

import { PhoneOrEmailInputField } from "@is/constants";
import { CheckoutInputFields, FieldState, FieldsValidation } from "@is/types";

import CheckoutFormField from "../CheckoutFormField";
import CheckoutFormSectionTitle from "../CheckoutFormSectionTitle";
import css from "./CheckoutFormSection.module.css";
import useManageCheckoutFormSection from "./hooks/useManageCheckoutFormSection";

type Props = {
  title: string;
  options: FieldState[];
  onChange: (name: CheckoutInputFields, type: string, value: string) => void;
  onSaveCheckoutInfo: () => void;
  validation: FieldsValidation;
  phoneOrEmailField?: PhoneOrEmailInputField;
  onPhoneOrEmailChange?: (name: PhoneOrEmailInputField) => void;
};

const CheckoutFormSection = ({
  title,
  options,
  onChange,
  onSaveCheckoutInfo,
  validation,
  phoneOrEmailField,
  onPhoneOrEmailChange,
}: Props) => {
  const { groupedOptions, fullWidthPhoneOrEmailField } =
    useManageCheckoutFormSection({ options });

  return (
    <div className={css.container}>
      <CheckoutFormSectionTitle title={title} />
      <div
        className={classcat([
          css.fieldsContainer,
          { [css.fullWidthLastItem]: fullWidthPhoneOrEmailField },
        ])}
      >
        {groupedOptions.map((option, index) =>
          Array.isArray(option) ? (
            <div
              className={classcat([
                css.fieldsContainer,
                { [css.fullWidthFieldsContainer]: option.length === 1 },
              ])}
              key={`option_${index}`}
            >
              {option.map((field) => (
                <CheckoutFormField
                  key={field.id}
                  field={field}
                  validation={validation}
                  onChange={onChange}
                  onSaveCheckoutInfo={onSaveCheckoutInfo}
                  phoneOrEmailField={phoneOrEmailField}
                  onPhoneOrEmailChange={onPhoneOrEmailChange}
                />
              ))}
            </div>
          ) : (
            <CheckoutFormField
              key={option.id}
              field={option}
              validation={validation}
              onChange={onChange}
              onSaveCheckoutInfo={onSaveCheckoutInfo}
              phoneOrEmailField={phoneOrEmailField}
              onPhoneOrEmailChange={onPhoneOrEmailChange}
            />
          )
        )}
      </div>
    </div>
  );
};
export default CheckoutFormSection;
